import { render, staticRenderFns } from "./SafetyBriefing.vue?vue&type=template&id=6f07a85a&scoped=true"
import script from "./SafetyBriefing.vue?vue&type=script&lang=js"
export * from "./SafetyBriefing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07a85a",
  null
  
)

export default component.exports